import { createApp } from 'vue';
import MainMenu from './MainMenu.vue'
import SubMenu from './SubMenu.vue'
import store from './store/index';
import ResponsiveMainMenu from './ReponsiveMainMenu';

const mainMenu = createApp(MainMenu);
const subMenu = createApp(SubMenu);
const responsiveMainMenu = createApp(ResponsiveMainMenu)

mainMenu.use(store);
mainMenu.mount('#navi-main');
subMenu.use(store);
subMenu.mount('#navi-sub');

responsiveMainMenu.use(store);
responsiveMainMenu.mount('#responsive-menu');
